import AppointmentWarningPopup from './AppointmentWarningPopup';

export default AppointmentWarningPopup;
